import { Routes } from '@angular/router';
import { authenticatedRouteGuards, canActivateUser } from '@shared/guard/guard';
import { PageKey } from '@shared/services/page/models/page.key';

export const reportsRoute: Routes = [
  {
    path: 'reports/projects',
    loadComponent: () => import('./pages/projects-report-list/projects-report-list.component').then(m => m.ProjectsReportListComponent),
    canActivate: [...authenticatedRouteGuards, canActivateUser],
    data: {
      title: 'Relatório de projetos',
      key: PageKey.REPORTS_PROJECTS
    }
  }
];
